import { Component, DoCheck, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { CustomValidatorService } from '../../../service/custom-validator.service';
import { ProviderService } from '../../../service/provider.service';

@Component({
  selector: 'app-provider',
  templateUrl: './provider.component.html',
  styleUrls: ['./provider.component.less']
})
export class ProviderComponent implements OnInit, DoCheck {

  // 业务类型提示框
  typeTooltip = '请选择';
  // 业务类型上一次的值
  lastJobTypeSelected: number;
  jobTypeSelected = -1;
  @ViewChild('typeTreeSelect') typeTreeSelect: NzTreeSelectComponent;
  @Input() code = 0; // 0表示新建 1表示编辑 2表示查看预览
  @Input() pno: any; // 供应商编号
  provider = null;
  beforeValue = '';
  typeMap = new Map<number, any>();
  pTypes = [];
  directors = [];
  validateForm: FormGroup;

  constructor(
    private customValidatorService: CustomValidatorService,
    private modalService: NzModalService,
    private message: NzMessageService,
    private providerService: ProviderService,
    private fb: FormBuilder,
    private store: Store,
  ) { }

  async ngOnInit(): Promise<void> {
    this.validateForm = this.fb.group({
      pname: [null, [Validators.required]], // 供应商名称
      pcode: [null, [Validators.required]], // 供应商代码
      ptype: [null, [Validators.required]], // 供应商类型
      paddr: [null], // 供应商地址
      pemail: [null, [Validators.email]], // 供应商邮箱
      pphone: [null], // 供应商电话
      pcontact: [null], // 供应商联系人
      cphone: [null], // 供应商电话
      cemail: [null, [Validators.email]], // 供应商邮箱
      qualifyReview: [null], // 供应商资质审查
      performanceEvaluation: [null], // 供应商表现评估
      comprehensiveEvaluation: [null], // 供应商综合评定
      continuUse: [null],  // 选用/续用
      director: [null],
      mark: [null] // 备注
    });
    await this.providerService.getProviderTypeList().then((data) => {
      this.initTypeTree(data);
    });
    await this.providerService.getDirectors().then((data) => {
      this.directors = data;
    });
    if (this.code === 1 || this.code === 2) {
      await this.providerService.getProvider(this.pno).then((data) => {
        this.provider = data;
      });
      this.setValidateForm(this.provider);
      if (this.code === 2) {
        this.validateForm.disable();
      }
    }
  }
  treeSelectChanged(key) {
    this.fillTypeTooltip(key);
    if (!this.isEmpty(key)) {
      const node = this.typeTreeSelect.getTreeNodeByKey(key);
      if (node != null) {
        if (node.isLeaf) {
          this.beforeValue = key;
        } else {
          this.validateForm.get('ptype').setValue(this.beforeValue);
        }
      }
    }
  }

  ngDoCheck(): void {
    // 监听业务类型变量的数据变化
    if (this.lastJobTypeSelected !== this.jobTypeSelected && this.typeTreeSelect) {
      this.lastJobTypeSelected = this.jobTypeSelected;
      this.fillTypeTooltip(this.jobTypeSelected);
    }
  }

  fillTypeTooltip(key) {
    if (key !== undefined && key !== null) {
      if (this.typeTreeSelect) {
        let currentNode = this.typeTreeSelect.getTreeNodeByKey(key);
        if (currentNode != null) {
          // 获取叶子节点完整路径，用于提示框
          let toolTip = `${currentNode.origin.title}`;
          while (currentNode.getParentNode()) {
            currentNode = currentNode.getParentNode();
            toolTip = `${currentNode.origin.title}-->${toolTip}`;
          }
          this.typeTooltip = toolTip;
        }
      }
    }
  }
  setValidateForm(provider: any) {
    this.validateForm.get('pname').setValue(!this.isEmpty(provider.pname) ? provider.pname : null);
    this.validateForm.get('pcode').setValue(!this.isEmpty(provider.pcode) ? provider.pcode : null);
    this.validateForm.get('ptype').setValue(!this.isEmpty(provider.ptype) ? Number(provider.ptype) : null);
    this.validateForm.get('paddr').setValue(!this.isEmpty(provider.paddr) ? provider.paddr : null);
    this.validateForm.get('pemail').setValue(!this.isEmpty(provider.pemail) ? provider.pemail : null);
    this.validateForm.get('pphone').setValue(!this.isEmpty(provider.pphone) ? provider.pphone : null);
    this.validateForm.get('pcontact').setValue(!this.isEmpty(provider.pcontact) ? provider.pcontact : null);
    this.validateForm.get('cphone').setValue(!this.isEmpty(provider.cphone) ? provider.cphone : null);
    this.validateForm.get('cemail').setValue(!this.isEmpty(provider.cemail) ? provider.cemail : null);
    this.validateForm.get('qualifyReview').setValue(!this.isEmpty(provider.qualifyReview) ? provider.qualifyReview : null);
    this.validateForm.get('performanceEvaluation').setValue(
      !this.isEmpty(provider.performanceEvaluation) ? provider.performanceEvaluation : null);
    this.validateForm.get('comprehensiveEvaluation').setValue(
      !this.isEmpty(provider.comprehensiveEvaluation) ? provider.comprehensiveEvaluation : null);
    this.validateForm.get('continuUse').setValue(!this.isEmpty(provider.continuUse) ? provider.continuUse : null);
    this.validateForm.get('mark').setValue(!this.isEmpty(provider.mark) ? provider.mark : null);
    this.validateForm.get('director').setValue(!this.isEmpty(provider.director) ? provider.director : null);
    this.validateForm.controls.comprehensiveEvaluation.disable();
  }
  initTypeTree(types: any[]) {
    const pTypes = [];
    this.typeMap.clear();
    for (const type of types) {
      const node = {
        title: type.typeName,
        value: type.typeId,
        key: type.typeId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        pTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.typeId, node);
    }
    this.pTypes = pTypes;
  }

  getAllTypes(id: number): number[] {
    let types: number[] = [];
    types.push(id);
    const type = this.typeMap.get(id);
    if (type != null && type.children != null) {
      for (const child of type.children) {
        types = types.concat(this.getAllTypes(child.value));
      }
    }
    return types;
  }
  getProviderForm() {
    return this.validateForm;
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }

}
